import styled from "styled-components";
import Flag from "react-world-flags";
import theme from "../../styles/theme";

export const StyledHeader = styled.div`
  display: flex;
  height: ${(props) => (props.isMobile ? "5.625rem" : "4.188rem")};
  background-color: ${theme.color.headerFooterBg};
  padding: ${(props) =>
    props.isMobile ? "0 1.5rem 1.5rem 1.5rem" : "0 1.5rem"};
  align-items: ${(props) => props.isMobile && "flex-end"};
`;

export const StyledLinksContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.isMobile ? "column" : "row")};
  justify-content: center;
  align-items: center;
`;

export const StyledLink = styled.a`
  margin-left: ${(props) => (props.removeMargin ? "1.5rem" : "3.875rem")};
  color: ${theme.color.white};
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
`;

export const StyledLanguageSelectorContainer = styled.div`
  display: flex;
  flex: auto;
  align-items: center;
  justify-content: center;
`;

export const StyledSpace = styled.div`
  display: flex;
  flex: auto;
`;

export const StyledLanguage = styled.div`
  color: ${theme.color.white};
  font-size: 0.938rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 1.5rem;
  margin-bottom: ${(props) => props.isMobile && "0.5rem"};
  cursor: pointer;
`;

export const StyledFlag = styled(Flag)`
  margin-left: 0.5rem;
`;

export const StyledMobileButtonContainer = styled.div`
  display: flex;
  flex: auto;
`;

export const StyledButton = styled.button`
  background-color: transparent;
  color: ${theme.color.white};
  cursor: pointer;
  display: flex;
  flex: auto;
  flex-direction: column;
  justify-content: center;
  max-width: 1.2rem;
  padding: 4rem 0 0.3rem 0;
  margin: 0;
  border: none;
`;

export const StyledLine = styled.div`
  width: 1.1875rem;
  height: 2px;
  margin-bottom: 4.5px;
  border-radius: 1px;
  background-color: ${theme.color.white};
`;

export const StyledImg = styled.img`
  display: flex;
  max-width: ${(props) => (props.isMobile ? "13rem" : "17.5rem")};
  position: relative;
  top: ${(props) => (props.isMobile ? "0.5rem" : "0")};
  left: -0.875rem;
`;
